import { CircularProgress, Stack } from "@mui/material";
import PropTypes from "prop-types";

export const CenteredLoading = ({ sx }) => (
  <Stack
    sx={{
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      ...sx,
    }}
  >
    <CircularProgress />
  </Stack>
);

CenteredLoading.propTypes = {
  sx: PropTypes.object,
};
